import CryptoJS from "crypto-js";
import { isObject } from "__barrel_optimize__?names=isObject!=!lodash-es";
import { SECRET_IV, SECRET_KEY } from "./config";
/**
 * AES 加密
 * @param data
 * @returns
 */
const encrypt = data => {
  if (isObject(data)) {
    try {
      data = JSON.stringify(data);
    } catch (e) {
      throw new Error("encrypt error" + e);
    }
  }
  const dataHex = CryptoJS.enc.Utf8.parse(data);
  const encrypted = CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
    iv: SECRET_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString();
};
/**
 * AES 解密
 * @param data
 * @returns
 */
const decrypt = data => {
  //解密
  const encryptedHexStr = CryptoJS.enc.Hex.parse(data);
  const str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const decrypt = CryptoJS.AES.decrypt(str, SECRET_KEY, {
    iv: SECRET_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
};
const aesCrypto = {
  encrypt,
  decrypt
};
export default aesCrypto;